export const VERSION_PREFERENCE_STORAGE_KEY = 'acreconnect.versionPreference';

export const VERSION_PREFERENCE = {
    V1: 'v1',
    V2: 'v2'
} as const;
